/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Totp_Enroll_Verify_DescriptionInputs */

const fr_totp_enroll_verify_description = /** @type {(inputs: Totp_Enroll_Verify_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entre le code à 6 chiffres affiché dans ton application d'authentification pour confirmer l'activation.`)
};

/**

* @param {Totp_Enroll_Verify_DescriptionInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const totp_enroll_verify_description = /** @type {((inputs?: Totp_Enroll_Verify_DescriptionInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Totp_Enroll_Verify_DescriptionInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_totp_enroll_verify_description(inputs)
});